import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from './loader/loader';
import { ArrowRightOutlined, DateRangeOutlined } from '@mui/icons-material';
import ReactPaginate from 'react-paginate';

const NewsLists = ({ news, isLoading, totalPages, handlePageChange, currentPage }) => {
    const { t, i18n } = useTranslation();

    const getNewsName = (news) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return news?.rus_name;
        } else if (currentLang === 'en') {
            return news?.eng_name;
        }
        return news?.tm_name;
    };

    const getNewsContent = (news) => {
        const currentLang = i18n.language;
        let content = '';
        if (currentLang === 'ru') {
            content = news?.rus_content;
        } else if (currentLang === 'en') {
            content = news?.eng_content;
        } else {
            content = news?.tm_content;
        }
        const words = content.split(' ');
        const maxWords = 100;
        if (words.length > maxWords) {
            return words.slice(0, maxWords).join(' ') + '...';
        }
        return content;
    };

    return (
        <div className='media'>
            {isLoading ? <Loading /> : (
                <div className='bg-white dark:bg-dark 
                                px-6 xl:px-16 lg:py-4 pb-4'>
                    {news?.map((n, index) => (
                        <div
                            className={`lg:flex justify-between gap-16 py-6
                                     ${index !== news.length - 1 ? 'border-b border-b-border' : ''}
                                     ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
                            key={n.id}
                        >

                            <section className='lg:w-[30%]'>
                                <img
                                    src={n.photo}
                                    alt="news"
                                    loading="lazy"
                                    className='object-contain w-full rounded-lg max-h-[300px]'
                                />
                            </section>

                            <section className='lg:w-[70%] dark:text-dark-text 
                                                h-full animate-slide-in mt-6 lg:mt-0'>
                                <h2 className='text-primary dark:text-white font-bold text-xl'>
                                    {getNewsName(n)}
                                </h2>
                                <div className='overflow-hidden text-text dark:text-dark-text 
                                              line-clamp-5 mt-4 text-justify'>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: document ?
                                                getNewsContent(n) : ''
                                        }}
                                        className='leading-loose'
                                    />
                                </div>
                                <span className='flex justify-between mt-8'>
                                    <p className='text-blackOpacity dark:text-dark-text
                                                  flex items-center gap-1'>
                                        <DateRangeOutlined style={{ fontSize: '20px', marginBottom: '2px' }} />
                                        {n.date}
                                    </p>

                                    <div className="mt-2">
                                        <Link
                                            to={`/news/${n.id}`}
                                            className="text-white bg-primary py-2 px-6 rounded-lg
                                                   dark:text-dark-text hover:text-primary
                                                   hover:bg-white hover:border dark:hover:bg-dark 
                                                   transition-all duration-300 ease-in-out 
                                                   transform hover:translate-x-1 font-semibold"
                                        >
                                            {t('all_button')} <ArrowRightOutlined />
                                        </Link>
                                    </div>
                                </span>
                            </section>
                        </div>
                    ))}

                    <div className="flex justify-center my-8">
                        <ReactPaginate
                            previousLabel={"<"}
                            nextLabel={">"}
                            pageCount={totalPages}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            previousClassName={"page-item"}
                            nextClassName={"page-item"}
                            forcePage={currentPage - 1} 
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default NewsLists;
